/**
 * App saga functions
 */
import { call, put, takeLatest, select } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';

const { Auth, User } = Constants;
const appReducer = (state) => state.get('appReducer');

/**
 * Fetches the current user and dispatches success or error.
 */
export function* getCurrentUser() {
  try {
    const response = yield call(UserAPI.getCurrentUser);
    const { user, authToken } = response;
    yield put(Actions.getCurrentUserSuccess({ authToken, user }));
  } catch (err) {
    yield handleError(Actions.getCurrentUserError, err);
  }
}

/**
 * Fetches the current OneLogin user and dispatches success or error.
 */
export function* getCurrentOneLoginUser() {
  try {
    const response = yield call(UserAPI.getCurrentOneLoginUser);
    const { user, authToken } = response;
    yield put(Actions.getCurrentOneLoginUserSuccess({ authToken, user }));
  } catch (err) {
    yield handleError(Actions.getCurrentUserError, err);
  }
}

/**
 * Logouts current OneLogin user and dispatches success or error.
 */
export function* logoutUser() {
  const state = yield select(appReducer);
  try {
    // OneLogin logout
    if (state.get('isSSOLoggedIn')) {
      yield call(UserAPI.logoutOneLoginUser);
      yield put(Actions.logoutOneLoginUserSuccess());
    } else {
      // App logout
      yield put(Actions.logoutUserSuccess());
    }
  } catch (err) {
    yield handleError(Actions.logoutOneLoginUserError, err);
  }
}

/**
 * Gets the response object from the latest request fired
 * to get the current user.
 */
function* appSaga() {
  yield takeLatest(User.GET_CURRENT_USER, getCurrentUser);
  yield takeLatest(User.GET_CURRENT_ONELOGIN_USER, getCurrentOneLoginUser);
  yield takeLatest(Auth.LOGOUT, logoutUser);
}

export default appSaga;
